import { Component, OnInit, ElementRef } from '@angular/core';
import { Inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { DOCUMENT } from '@angular/common';
import { CommonService } from '../../common.service';
import Swal from 'sweetalert2/dist/sweetalert2.js';
declare let swal: any;
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
declare var $: any;
declare var jQuery: any;
@Component({
  selector: 'app-addbreedsmanagement',
  templateUrl: './addbreedsmanagement.component.html',
  styleUrls: ['./addbreedsmanagement.component.css']
})
export class AddbreedsmanagementComponent implements OnInit {
  returnUrl = "/dashboard/breedsmanagement";
  samepageroute: any = "dashboard/addbreedsmanagement";
  addUrl: any;
  newArray: any = [];
  addUrlbreeds: any;
  addBreedsFormValue: any;
  loadspeciesValue: any = [];
  registerForm: FormGroup;
  submitted = false;
  selectAllText = true;
  getfarmdata: any;
  languages: any;
  farmnonworkingid: any = [];
  farmworkingid: any = [];
  getlistApi: any;
  getidvalue: any;
  speciesloaddata: any = [];
  getfarmsvalue: any = [];
  farmidhavesamespecies: any = [];
  getfarmsListData: any;
  dummy: any = [];
  strval: any;
  getfarmlistApi: any;
  storedata: any = [];
  getspeciesfarmdata: any = [];
  strdata: any;
  getfarmlistid: any;
  selectallvalue: any;
  getspeciesListData: any = [];
  getfarmlistidfarm: any;
  loginresponse: any;
  result: any;
  getidvaluefarm: any;
  farm_userrole: any;
  userrole: any;
  cby_mby: any;
  isLoading: boolean = false;
  Object = Object;
  selectedSpeciesFarmId: any;
  constructor(private elementRef: ElementRef, private router: Router, private commonService: CommonService, private formBuilder: FormBuilder, @Inject(DOCUMENT) private doc: Document) { }

  async ngOnInit() {

    this.reloadOnce();

    this.isLoading = true;
    this.loginresponse = JSON.parse(sessionStorage.getItem('userrole'));
    this.userrole = this.loginresponse.read_status;
    this.cby_mby = this.loginresponse.user_id;
    this.farm_userrole = this.loginresponse.user_farm_id;
    if (this.farm_userrole) {
      $("#farmname").attr("disabled", "disabled")
    }

    $('.selectpicker').selectpicker('refresh');
    this.registerForm = this.formBuilder.group({
      breedname: ['', Validators.required],
      breedid: ['', Validators.required],
      //  speciesid:['', Validators.required]
      // status: ['', Validators.required]
    });

    this.getlistApi = "/farms";
    (await this.commonService.getApi(this.getlistApi)).subscribe(
      async (res) => {
        this.getfarmsListData = res.data;
        console.log('farmsdata', this.getfarmsListData)
        setTimeout(() => {
          $(function () {
            $('#farmname').multiselect({
              selectedText: "# of # selected",
              includeSelectAllOption: true,
              buttonText: function (options) {
                if (options.length == 0) {
                  return ' None selected ';
                } else {
                  var selected = 0;
                  options.each(function () {
                    selected += 1;
                  });
                  return selected + ' Selected ';
                }
              },
              enableFiltering: true,
              enableCaseInsensitiveFiltering: true,
              filterPlaceholder: 'Search for something...',
              onChange: function (option, checked, select) {
                this.selectedmultidata = $('#farmname').val();
                console.log(this.selectedmultidata);
              }
            });
          });
          this.isLoading = false;
        },);

        //farm user role based on view 
        if (this.farm_userrole) {
          setTimeout(() => {
            var optionVal = this.farm_userrole;
            console.log(this.farm_userrole);
            $("#farmname").find("option[value=" + optionVal + "]").prop("selected", "selected");

          }, 500);
          setTimeout(() => {
            $("#farmname").multiselect('refresh');
          }, 1000);

          this.loadspeciesValue = {
            "farms_id": this.farm_userrole
          }
          //this.addUrl = "/species/farms";
          this.addUrl = "/species/list/drop_down";
          (await this.commonService.postApi(this.addUrl, this.loadspeciesValue)).subscribe(
            res => {
              this.speciesloaddata = res.data;
              console.log(this.speciesloaddata)
              setTimeout(function () {
                $('.selectpicker').selectpicker('refresh');   // refresh the selectpicker with fetched courses
              }, 1500);
            })


        }
        //farm user role based on view end
        $('#farmname').change(async () => {
          $("#speciesid").find('option').remove().end();

          this.selectallvalue = $('#farmname').val().toString();
          var farmvalue = "";
          farmvalue = this.selectallvalue;
          console.log(farmvalue)
          console.log("Farm_name_value", this.selectallvalue)
          this.loadspeciesValue = {
            "farms_id": farmvalue
          };
          console.log(this.loadspeciesValue.farms_id)
          //species load in select dropdown based on farm select api call
          this.addUrl = "/species/list/drop_down";
          (await this.commonService.postApi(this.addUrl, this.loadspeciesValue)).subscribe(
            res => {
              this.speciesloaddata = res.data;
              console.log(this.speciesloaddata)
              setTimeout(function () {
                $('.selectpicker').selectpicker('refresh');   // refresh the selectpicker with fetched courses
              }, 1500);
            })

        });

        $('.selectpicker').selectpicker('refresh');   // refresh the selectpicker with fetched courses

      })

    $(document).on('change', '#status', function () {
      $('.myFakeClass').dropdown('toggle');
    });

    $(document).on('change', '#speciesid', function () {
      $('.myFakeClass1').dropdown('toggle');
    });

  }


  async reloadOnce() {     // --> The Page will reload once initially  

    const hasReloaded = sessionStorage.getItem('hasReloaded');

    if (!hasReloaded) {
      window.location.reload();
      sessionStorage.setItem('hasReloaded', 'true');
    }
  }

  

  async farmbasedonspecies(event) {
    //$('#farmname').val([]);
    //$("farmname").remove("option");
    $("#farmname").multiselect('destroy');
    this.getfarmsvalue = [];
    //$("#farmname").attr('value');
    //  $("#farmname").find('<option></option>').value([]).remove();
    /*$('#farmname option').load(function () {
      //this.languages.deselectAll();
      alert()
    }).remove();*/
    setTimeout(() => {
      /*let currentUrl = this.samepageroute;
      this.router.navigateByUrl('/', {skipLocationChange: true}).then(() => {
          this.router.navigate([currentUrl]);
      });  */

      // $('#farmname').find('option').remove();
    },)


    console.log(event.target.value);
    this.addUrl = "/species/species/" + event.target.value;
    (await this.commonService.getApi(this.addUrl)).subscribe(
      res => {
        this.getfarmsvalue = [];
        this.getfarmsvalue = res.data;
        /* $.each(this.getfarmsvalue, function(key, value) {
           $('#farmname').append($('<option>', {
               value:value.farm_id,
               text:value.farm_name
           }))
           
         });*/

        setTimeout(() => {
          $(function () {
            $('#farmname').multiselect({
              includeSelectAllOption: true,
              enableFiltering: true,
              enableCaseInsensitiveFiltering: true,
              filterPlaceholder: 'Search for something...'
            });
          });
          /* this.languages= $('#farmname').filterMultiSelect({
           
             placeholderText:"nothing selected",
             // placeholder for search field
             filterText:"Filter",
             // Select All text
         
             selectAllText:"Select All",
             // determine if is case sensitive
         
             caseSensitive:false,
         
       
             allowEnablingAndDisabling:true   
           
             
         
           });*/


        }, 100);


      });

  }
  get f() { return this.registerForm.controls; }
  onSubmit() {
    this.submitted = true;

    // stop here if form is invalid
    if (this.registerForm.invalid) {
      return;
    }

    // display form values on success
    this.breedsmanagement()

  }
  async getspeciesvalue(e) {
    /* $('#select_all').click(function() {
       $('#countries option').prop('selected', true);
   });*/
    this.getfarmdata = $('#farmname').val();
    var res = e.target.value.split("and");
    var speciesid = res[1];
    var getval = speciesid.trim()
    console.log(getval)
    this.getfarmlistApi = "/species/species/" + getval;
    (await this.commonService.getApi(this.getfarmlistApi)).subscribe(
      (res) => {
        console.log('test');
        console.log(this.speciesloaddata);
        console.log('test');
        this.farmnonworkingid = [];
        this.farmworkingid = [];
        console.log(res.data[0].farm_id);
        var selectedspeciesfarmid = res.data[0].farm_id;
        console.log('farmidddd', selectedspeciesfarmid)
        var resultarryfarmid = selectedspeciesfarmid.split(',');
        console.log(resultarryfarmid)
        console.log(this.getfarmdata)
        /*var resunmatchid =this.getfarmdata.filter( function(n) {  this.has(n) }, new Set(resultarryfarmid) );
        console.log(resunmatchid)*/
        let concat = this.getfarmdata.concat(resultarryfarmid)

        this.selectedSpeciesFarmId = selectedspeciesfarmid;

        //find same occurence
        let findDuplicates = concat => concat.filter((item, index) => concat.indexOf(item) != index)
        // this.farmidhavesamespecies=([...new Set(findDuplicates(concat))])
        console.log(this.farmidhavesamespecies)
        var clean_array = $.map(concat.sort(), function (v, i) {
          concat[i] === concat[i + 1] && (concat[i] = concat[i + 1] = null);
          return concat[i];
        });
        //
        let concatinateforalert = this.getfarmdata.concat(this.farmidhavesamespecies)
        var clean_array1 = $.map(concatinateforalert.sort(), function (v, i) {
          concatinateforalert[i] === concatinateforalert[i + 1] && (concatinateforalert[i] = concatinateforalert[i + 1] = null);
          return concatinateforalert[i];
        });
        console.log(clean_array1)
        //

        var a = clean_array1
        var resultparseint = a.map(function (x) {
          return parseInt(x);
        });
        console.log(resultparseint)
        var getunmatchedfarm = this.getfarmsListData.filter(function (x) { return this.has(x.tnfr_id) }, new Set(resultparseint));
        console.log(getunmatchedfarm);
        this.result = "";
        for (var i = 0; i < getunmatchedfarm.length; i++) {
          this.result += "This species doesn't added to" + getunmatchedfarm[i].tnfr_name + "Farm" + "<br>"
        }
        console.log(this.result);
        if (this.result == "") {
          Swal.fire("Wrong Species Selection", this.result);
        }


      })
  }
  async breedsmanagement() {
    var speciesid = $("#speciesid").val();
    var res = speciesid.split("and");
    console.log(res);
    var clrspc = res[0];
    var getval = clrspc.trim();
    console.log(getval)

    console.log('Selected Species Farm Id:', this.selectedSpeciesFarmId);


    // var myArray = this.farmidhavesamespecies.toString();
    var Farmid = this.selectedSpeciesFarmId;

    //console.log(typeof(farmvalue));
    this.addBreedsFormValue = {
      "name": $("#breedname").val(),
      "family_name": "Dog",
      "breedID": $("#breedid").val(),
      "farm_id": Farmid,
      "species_id": getval,
      "status": $("#status").val(),
      "is_active": 1,
      "cby": this.cby_mby,
    };
    console.log(this.addBreedsFormValue)
    if (this.farmidhavesamespecies.length !== null) {
      console.log(this.addBreedsFormValue.farm_id);
      this.addUrlbreeds = "/breeds";
      (await this.commonService.postApi(this.addUrlbreeds, this.addBreedsFormValue)).subscribe(
        data => {
          alert("Data added successfully")
        });

      setTimeout(
        (): void => {

          this.router.navigate([this.returnUrl]);

        },
        500
      );

    } else {
      alert("Enter the correct species name")
    }


  }

  backtobreeds() {
    this.router.navigate([this.returnUrl]);
  }
  backnavigate() {
    this.router.navigate([this.returnUrl]);
  }
}


